export const AppActions = {
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
};

export const AppActionCreators = {
  toggleSidebar: () => ({
    type: AppActions.TOGGLE_SIDEBAR,
    payload: {},
  }),
};
